import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import ButtonComponent from '../../Button.component';
import SelectComponent, {
  SelectOptionProps,
} from '../../Input/Select.component';

interface SelectRegionModalProps {
  label: string;
  placeholder: string;
  options: SelectOptionProps[];
  onConfirmClick: (a: string) => void;
}

const SelectRegionModalWrapper = styled.div`
  width: 350px;
  height: 380px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

export default function SelectRegionModal({
  label,
  placeholder,
  options,
  onConfirmClick
}: SelectRegionModalProps) {
  const [selectedRegion, setSelectedRegion] = useState('');
  const { t } = useTranslation();

  function handleChangeOption(a: SelectOptionProps) {
    setSelectedRegion(a.value.toString());
  }

  function handleClick() {
    onConfirmClick(selectedRegion);
  }


  return (
    <SelectRegionModalWrapper>
      <SelectComponent
        label={label}
        placeholder={placeholder}
        options={options}
        onChangeOption={handleChangeOption}
        menuPlacement='bottom'
      />
      <ButtonComponent
        handleClick={handleClick}
        disabled={selectedRegion.length === 0}
      >
        {t("Save")}
      </ButtonComponent>
    </SelectRegionModalWrapper>
  );
}
